import React, { Component } from "react";
import { connect } from "react-redux";
import AdSense from "react-adsense";
import Lightbox from "react-images";
import axios from "axios";

class Ranking extends Component {
  constructor() {
    super();
    this.state = {
      list: null,
      lightbox: {
        s0: false,
        s1: false,
        s2: false,
        s3: false,
        s4: false,
        s5: false,
        s6: false,
        s7: false,
        s8: false,
        s9: false,
        s10: false,
        s11: false,
        s12: false,
        s13: false,
        s14: false,
        s15: false,
        s16: false,
        s17: false,
        s18: false,
        s19: false,
        s20: false,
        s21: false,
        s22: false,
        s23: false,
        s24: false,
        f0: false,
        f1: false,
        f2: false,
        f3: false,
        f4: false,
        f5: false,
        f6: false,
        f7: false,
        f8: false,
        f9: false,
        f10: false,
        f11: false,
        f12: false,
        f13: false,
        f14: false,
        f15: false,
        f16: false,
        f17: false,
        f18: false,
        f19: false,
        f20: false,
        f21: false,
        f22: false,
        f23: false,
        f24: false
      }
    };
  }
  componentWillMount() {
    axios
      .get("https://img.lookaliker.com/get_ranking.php")
      .then(response => {
        this.setState({ list: response.data });
      })
      .catch(err => {});
  }
  renderList() {
    var publi_count = 0;
    var publi_match = 0;
    if (this.state.list != null) {
      var returnValue = [];
      var background = "white";
      var element = "f0";
      var element_state_true = { f0: true };
      var element_state_false = { f0: false };
      var element_states_true = {};
      var element_states_false = {};
      var element2 = "s0";
      var element2_state_true = { s0: true };
      var element2_state_false = { s0: false };
      var element2_states_true = {};
      var element2_states_false = {};
      this.state.list.map((obj, index) => {
        if (index % 2 !== 0) {
          background = "#F8F8F8";
        } else {
          background = "white";
        }
        element = "f" + index;
        element_state_true = { ...this.state.lightbox };
        element_state_false = { ...this.state.lightbox };
        element_state_true[element] = true;
        element_state_false[element] = false;
        element_states_true[index] = element_state_true;
        element_states_false[index] = element_state_false;
        element2 = "s" + index;
        element2_state_true = { ...this.state.lightbox };
        element2_state_false = { ...this.state.lightbox };
        element2_state_true[element2] = true;
        element2_state_false[element2] = false;
        element2_states_true[index] = element2_state_true;
        element2_states_false[index] = element2_state_false;
        returnValue.push(
          <div
            key={index}
            style={{ backgroundColor: background, padding: "20px" }}
          >
            <h5 style={{ display: "inline-block", position: "absolute" }}>
              <p>
                <font color="#689BDF" style={{ fontSize: "100px" }}>
                  {index + 1}
                </font>
              </p>
            </h5>
            <center>
              <div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src={obj.img1}
                    alt={obj.name1}
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() =>
                      this.setState({ lightbox: element_states_true[index] })
                    }
                  />
                  <Lightbox
                    images={[
                      {
                        src: obj.img1,
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox[element]}
                    onClickImage={() =>
                      this.setState({ lightbox: element_states_false[index] })
                    }
                    onClose={() =>
                      this.setState({ lightbox: element_states_false[index] })
                    }
                    showImageCount={false}
                  />
                </div>
                <div className="crop" style={{ display: "inline-block" }}>
                  <img
                    src={obj.img2}
                    alt={obj.name2}
                    width="200px"
                    style={{ display: "inline-block" }}
                    onClick={() =>
                      this.setState({ lightbox: element2_states_true[index] })
                    }
                  />
                  <Lightbox
                    images={[
                      {
                        src: obj.img2,
                        caption: "Image from Wikipedia"
                      }
                    ]}
                    isOpen={this.state.lightbox[element2]}
                    onClickImage={() =>
                      this.setState({ lightbox: element2_states_false[index] })
                    }
                    onClose={() =>
                      this.setState({ lightbox: element2_states_false[index] })
                    }
                    showImageCount={false}
                  />
                </div>
              </div>
              <h6>
                <p>
                  {obj.name1} - {obj.name2}
                </p>
              </h6>
            </center>
          </div>
        );
        publi_count = publi_count + 1;
        publi_match = publi_match + 1;
        if (publi_match == 5 && publi_count != 25) {
          returnValue.push(
            <div>
              <br />
              <AdSense.Google
                client="ca-pub-1432281280543089"
                slot="2677980562"
              />
              <br />
            </div>
          );
          publi_count = 0;
        }
        return true;
      });

      return returnValue;
    } else {
      return null;
    }
  }
  render() {
    return (
      <div>
        <h5>
          <p>
            <font color="#689BDF">Ranking</font>
          </p>
        </h5>
        {this.renderList()}
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Ranking);



// WEBPACK FOOTER //
// ./src/components/Ranking.js